import axios from 'axios'
import { Toast } from 'vant'
import store from '@/store'
import { getToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
  baseURL: window.__config__.server_url,
  timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (store.state.token) {
      config.headers['Authorization'] = 'Bearer ' + store.state.token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    const code = response.status
    return res;
  },
  error => {
    let message = error.message;
    let code = 0;
    console.log('err' + error) // for debug

    if ('response' in error) {
      const response = error.response;
      const data = response.data;
      if ('message' in data) {
        message = data.message;
      }
      code = response.status
      // console.log('status', code, data, message)
    }

    if (code === 401) {
      store.dispatch('resetToken')
    }
    
    Toast({
      message: message,
      type: 'fail',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
